import React from 'react'
import DashboardCard from '../../../../components/DashboardCard'
import {Box, Stack, Typography} from '@mui/material'
import {FormattedMessage} from 'react-intl'
import ButtonDashboard from '../../../../components/ButtonDashboard'
import {useHistory} from 'react-router-dom'
import notificationBell from '../../../../resources/animation/notif_bell.json'
import Lottie from 'react-lottie'
import {SECONDARY_PATH} from '../../../../constant/path'
import {DemandeBean, SuivieDemandeLocationState} from '../../suivieDemande/components/demandeConstants'
import DownloadApp from './DownloadApp'
import demandeUtils from '../../../../utils/demandeUtils'

type NotificationsProps = {
	notifications: DemandeBean[],
	dateDerniereConnexion: string
}

const Notifications: React.FC<NotificationsProps> = ({ notifications, dateDerniereConnexion }) => {
	const history = useHistory()

	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: notificationBell,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}
	}

	const getDemandesEnAttente = () => {
		return demandeUtils.getDemandesEnAttente(notifications)
	}

	const getDevisSansDemande = () => {
		return notifications.filter(demande => demande.idDevis !== null && demande.idDevis !== undefined)
	}

	const getDemandeAConsulter = () => {
		return notifications.filter(demande => {
			return demande.dateDernierEtat !== null
				&& (new Date(demande.dateDernierEtat)).getTime() > (new Date(dateDerniereConnexion)).getTime()
				&& demande.etat.libelleEtat !== "Reçu(e)"
				&& demande.etat.libelleEtat !== "En cours"
		})
	}

	const displayAlert = () => {
		const demandesEnAttente = getDemandesEnAttente()
		const devisSansDemande = getDevisSansDemande()
		const demandeAConsulter = getDemandeAConsulter()

		let count = 0
		let messageId = 'notification.card.default'
		let messageValues = {}

		// Sur l'alerte « Demande(s) en attente de document(s) », on demande à la page de suivi
		// de se positionner sur la demande la plus ancienne en attente de pièce(s).
		const locationState: SuivieDemandeLocationState | undefined = demandesEnAttente.length > 0
			? { scrollToDemandeEnAttente: true }
			: undefined

		if (demandesEnAttente.length > 0) {
			count = demandesEnAttente.length
			messageId = 'notification.card.enAttente'
			messageValues = { nb: count }
		} else if (devisSansDemande.length > 0) {
			count = devisSansDemande.length
			messageId = 'notification.card.devis'
			messageValues = { nb: count }
		}

		if (demandesEnAttente.length > 0 || devisSansDemande.length > 0 || demandeAConsulter.length > 0) {
			return (
				<>
					<DashboardCard height="160px" cardContentPadding="24px">
						<Stack
							width="100%"
							direction="column"
						>
							<Stack direction="row" width="100%" height="80px" paddingRight="-24px" marginBottom="12px">
								<Stack direction="row" display="flex" alignItems="center" spacing="24px" width="100%" flex={2}>
									{count > 0 && (
										<Typography fontSize="2.5em" color="secondary" fontWeight="bold">
											{count}
										</Typography>
									)}
									<Typography variant="h4">
										<FormattedMessage id={messageId} values={messageValues} />
									</Typography>
								</Stack>
								<Box flex={1}>
									<Lottie
										options={defaultOptions}
										height={124}
										width={124}
										style={{ position: 'absolute', marginTop: '-74px' }} />
								</Box>
							</Stack>
							<Box width="100%" justifyContent="center" display="flex">
								<ButtonDashboard onClick={() => history.push({
									pathname: SECONDARY_PATH.SERVICES_HISTORIQUE_DEMANDE,
									state: locationState
								})}
								                 variant="outlined" size="small" sx={{ width: '100%' }}>
									<FormattedMessage id="dashboard.notification.buttons.displayAlert" />
								</ButtonDashboard>
							</Box>
						</Stack>
					</DashboardCard>
				</>
			)
		} else {
			return (
				<DownloadApp />
			)
		}

	}

	return (displayAlert())
}

export default Notifications
